import React, { useState } from 'react';
import { Modal, Button, Table } from 'react-bootstrap';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import apinode from '../../services/apinode';

const ModalTable = ({ data, showModal, handleClose }) => {
    const handleEstorno = async (id_pedido, qtd, sku) => {
        const confirmacao = window.confirm('Tem certeza que deseja estornar este item?');
        if (confirmacao) {
            // Implemente a lógica de estorno aqui
            try {
                const response = await apinode.put(
                    `/devolucoes/dev/parcial/${localStorage.idconta}`,
                    {
                        qtd: qtd,
                        sku: sku,
                        pedido: id_pedido,
                    },
                );

                if (response.status === 200) {
                    console.log('Estorno realizado');
                    toast.success(response.data.message);
                    // setPedido('');
                } else {
                    console.error(
                        'Erro ao solicitar estorno ao backend. Resposta:',
                        response.data,
                    );
                    toast.error(
                        `Erro ao solicitar estorno ao backend. Resposta: ${JSON.stringify(response.data)}`,
                    );
                    // setPedido('');
                }
            } catch (error) {
                console.error('Erro ao buscar contas:', error);
                toast.error(`Erro ao solicitar estorno. Resposta: ${error.message}`);
                // setPedido('');
            }

        }

    };

    return (
        <Modal show={showModal} onHide={handleClose} dialogClassName="custom-modalzpl">
            <Modal.Header>
                <Modal.Title>Lista de Itens</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Código</th>
                            <th>SKU</th>
                            <th>Quantidade</th>
                            <th>Pedido</th>
                            {/*     <th>Exportado</th> */}

                            <th>Data</th>
                            <th>Hora</th>
                            <th>Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map(item => (
                            <tr key={item.id}>
                                <td>{item.id}</td>
                                <td>{item.sku}</td>
                                <td>{item.qtde}</td>
                                <td>{item.id_pedido}</td>
                                {/*   <td>{item.exportado}</td> */}
                                <td>{format(new Date(item.data_conf), 'dd/MM/yyyy HH:mm:ss')}</td>
                                <td>{format(new Date(item.hora_conf), 'HH:mm:ss')}</td>
                                <td>
                                    <Button variant="outline-danger" size="sm" onClick={() => handleEstorno(item.id_pedido, item.qtde, item.sku)}>
                                        Estornar
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalTable;
